// extracted by mini-css-extract-plugin
export default {"layout":"LandingPage_layout__ut38l","topbar":"LandingPage_topbar__g1B-y","main":"LandingPage_main__CoVHw"};